import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { SALES_COLORS } from './theme';
import { formatCurrency, formatPercent, netCents } from './salesUtils';

// This video vs every other video, by NET revenue (after refunds) in the selected range.
const ShareDonut = ({ range, currency }) => {
  const mine = netCents(range);
  const others = Math.max(0, (range.total_net_cents ?? range.total_gross_cents ?? 0) - mine);
  const minePct = range.pct_of_revenue || 0;
  const data = [
    { name: 'This video', value: mine, color: SALES_COLORS.accent, pct: minePct },
    { name: 'All other videos', value: others, color: SALES_COLORS.neutral, pct: Math.max(0, 100 - minePct) },
  ];
  const slices = data.filter((d) => d.value > 0);
  return (
    <div className="sales-card h-full flex flex-col" data-testid="share-donut">
      <h3 className="sales-heading mb-2">Share of revenue</h3>
      <div className="relative h-44 sm:h-48 my-auto">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={slices}
              dataKey="value"
              innerRadius="72%"
              outerRadius="94%"
              startAngle={90}
              endAngle={-270}
              paddingAngle={slices.length > 1 ? 2 : 0}
              cornerRadius={3}
              stroke="none"
              isAnimationActive={false}
            >
              {slices.map((d) => <Cell key={d.name} fill={d.color} />)}
            </Pie>
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
          <span className="font-display font-semibold text-3xl text-brand-yellow leading-none sales-num">{formatPercent(minePct)}</span>
          <span className="sales-label mt-1.5">this video</span>
        </div>
      </div>
      <ul className="mt-4 space-y-2 text-sm">
        {data.map((d) => (
          <li key={d.name} className="flex items-center justify-between gap-2">
            <span className="flex items-center gap-2 text-gray-300 min-w-0">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: d.color }} aria-hidden="true" />
              <span className="truncate">{d.name}</span>
            </span>
            <span className="sales-num text-gray-400 whitespace-nowrap">
              {formatCurrency(d.value, currency)}
              <span className="text-gray-600"> &middot; </span>
              {formatPercent(d.pct)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShareDonut;
